import styled from "styled-components";

export const Container = styled.div`
  background: linear-gradient(to bottom, #982815, #EF7878);

  font-family: "Wix Madefor Display";
  font-size: 12px;

  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  max-width: max-content;

  display: flex;
  align-items: center;
  justify-content: center;

  gap: 8px;

  font-size: 14px;
`;